import { serialize } from 'object-to-formdata'
import snakecaseKeys from 'snakecase-keys'
import qs from 'qs'
import axiosIns from '@/plugins/axios'

export default {
  getTimecards({
    date = null,
    interval = null,
    userId = null,
    role = null,
    isWorking = false,
    endDate = null,
    isToday = false,
  }) {
    const config = {
      params: snakecaseKeys({
        date,
        interval,
        userId,
        role,
        isWorking,
        endDate,
        isToday,
      }),
      paramsSerializer(params) {
        return qs.stringify(params)
      },
    }

    return axiosIns.get('/waiter/timecards', config)
  },

  /**
  * @param {Timecard} timecard  create timecard based on this (argument) variable information。
  */
  createTimecard(timecard) {
    const formData = serialize(snakecaseKeys({
      timecard,
      userId: timecard.userId,
    }))

    // TODO error handling
    return axiosIns.post('/waiter/timecards', formData)
  },

  /**
  * @param {Timecard} timecard  update timecard based on this (argument) variable information。
  */
  updateTimecard(timecard) {
    const formData = serialize(snakecaseKeys({
      timecard,
    }))

    return axiosIns.put(`/waiter/timecards/${timecard.id}`, formData)
  },

  /**
  * 出勤ボタンからの打刻。出勤時刻ルールが有効な店舗では、サーバーが出勤時刻を決める。
  * 申告(配列)を送るため、form-data ではなく JSON で送る。
  */
  punchTimecard({
    userId,
    punchedAt,
    startAt = null,
    declarationItemIds = [],

    // [{ itemId, amount }]。出勤のときに金額を直した場合に送る
    declarations = [],
  }) {
    return axiosIns.post('/waiter/timecards', snakecaseKeys({
      userId,
      timecard: {
        userId,
        startAt,
        punch: { punchedAt, declarationItemIds, declarations },
      },
    }))
  },

  /**
  * 申告の変更を伴う更新。declarations: [{ itemId, amount }]。
  * 空の配列(申告をすべて外す)を送れるよう JSON で送る。
  */
  updateTimecardWithDeclarations(timecard, declarations) {
    return axiosIns.put(`/waiter/timecards/${timecard.id}`, snakecaseKeys({
      timecard: { ...timecard, declarations },
    }))
  },

  // 手で直した出勤時刻を、打刻した時刻と申告から決まる自動の時刻に戻す
  reapplyCheckInRule(id) {
    return axiosIns.post(`/waiter/timecards/${id}/reapply_check_in_rule`)
  },

  deleteTimecard(id) {
    return axiosIns.delete(`/waiter/timecards/${id}`)
  },
}
